/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MaintenanceWindowDto } from '../models/MaintenanceWindowDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaintenanceWindowControllerService {
    /**
     * @param uuid
     * @returns MaintenanceWindowDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<MaintenanceWindowDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/maintenance-windows/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns MaintenanceWindowDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: MaintenanceWindowDto,
    ): CancelablePromise<MaintenanceWindowDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/maintenance-windows/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/maintenance-windows/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns MaintenanceWindowDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<MaintenanceWindowDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/maintenance-windows',
        });
    }
    /**
     * @param requestBody
     * @returns MaintenanceWindowDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: MaintenanceWindowDto,
    ): CancelablePromise<MaintenanceWindowDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/maintenance-windows',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
